import { Component, OnInit, ViewChild } from '@angular/core';
import { UserApiService } from '../../services/user-api.service';
import { DrugStoreProfile, User } from '../../models/user';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { LoggerService } from 'src/app/services/logger.service';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css'],
})
export class UserProfileComponent {
  public constructor(
    private logger: LoggerService,
    private apiService: UserApiService,
    private translateService: TranslateService
  ) {
    this.userProfile = new User();
    this.drugStoreProfile = new DrugStoreProfile();
    this.getUser();
    this.getDrugStore();
  }

  @ViewChild('datePicker') public popoverDataPicker!: NgbPopover;

  public userProfile: User;
  public drugStoreProfile: DrugStoreProfile;
  public loadingUser: boolean = true;
  public loadingDrugStore: boolean = true;
  public monthName: string = '';
  public uploadImage: any;

  public changeMonth(val: string) {
    if (this.popoverDataPicker.isOpen()) {
      this.popoverDataPicker.close();
    }
    this.monthName = val;
  }

  public deliveryTypeDate() {
    this.userProfile.birthday = this.TypeDate('RecivedDate');
  }

  public TypeDate(elementId: string): string {
    const expiteValue = (<HTMLInputElement>(
      document.getElementById(`${elementId}`)
    )).value;

    const yearDatePattern: RegExp = /^(?<year>\d{4})$/;

    const testyearDatePattern: boolean = yearDatePattern.test(expiteValue);
    if (testyearDatePattern) {
      return `${expiteValue}/`;
    }

    const monthDatePattern: RegExp = /^(?<year>\d{4})(\/{1})(?<month>\d{2})$/;

    const testmonthDatePattern: boolean = monthDatePattern.test(expiteValue);
    if (testmonthDatePattern) {
      const groups = expiteValue.match(monthDatePattern)?.groups;
      const year: number = Number(groups?.['year']);
      const month: number = Number(groups?.['month']);

      let monthString = month.toString();
      if (month < 10) {
        monthString = monthString.padStart(2, '0');
      } else if (month > 12) {
        monthString = '12';
      }

      return `${year}/${monthString}/`;
    }

    const fullDatePattern: RegExp =
      /^(?<year>\d{4})(\/{1})(?<month>\d{1,2})(\/{1})(?<day>\d{1,})/;
    const testfullDatePattern: boolean = fullDatePattern.test(expiteValue);
    if (testfullDatePattern) {
      const groups = expiteValue.match(fullDatePattern)?.groups;
      const year: number = Number(groups?.['year']);
      const month: number = Number(groups?.['month']);
      const day: number = Number(groups?.['day']);

      let monthString = month.toString();
      if (month < 10) {
        monthString = monthString.padStart(2, '0');
      } else if (month > 12) {
        monthString = '12';
      }

      let dayString = day.toString();
      if (day < 10) {
        dayString = dayString.padStart(2, '0');
      } else if (day > 31) {
        dayString = '30';
      }

      return `${year}-${monthString}-${dayString}T12:00:00`;
    }

    return expiteValue;
  }

  private getUser(): void {
    try {
      let url = `Account/GetMe`;
      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }
      this.apiService.getSingleItem(new ApiRequestModel(url)).subscribe(
        (result) => {
          if (result.succeeded) {
            this.userProfile = result.data;
            this.userProfile.imageurl=this.apiService.fixImage(this.userProfile.imageurl);
            this.logger.addResponseLog(url, result, `get Single Item`);
          } else {
            this.apiService.AddErrorLog(result);
          }
          this.loadingUser = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loadingUser = false;
        },
        () => {
          this.loadingUser = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loadingUser = false;
    }
  }

  private getDrugStore() {
    try {
      let url = `Account/MyDrugStore`;
      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }
      this.apiService.getSingleItem(new ApiRequestModel(url)).subscribe(
        (result) => {
          if (result.succeeded) {
            this.drugStoreProfile = result.data;
            this.logger.addResponseLog(url, result, `get Single Item`);
          } else {
            this.apiService.AddErrorLog(result);
          }
          this.loadingDrugStore = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loadingDrugStore = false;
        },
        () => {
          this.loadingDrugStore = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loadingDrugStore = false;
    }
  }

  private checkValidation() {
    let validation = true;

    try {
      if (this.userProfile.firstName == null) {
        this.userProfile.firstNameValidation =
          this.translateService.instant('Required');
        validation = false;
      } else if (this.userProfile.firstName.length < 3) {
        this.userProfile.firstNameValidation =
          this.translateService.instant('invalid_Length');
        validation = false;
      } else {
        this.userProfile.firstNameValidation = undefined;
      }

      if (this.userProfile.lastName == null) {
        this.userProfile.lastNameValidation =
          this.translateService.instant('Required');
        validation = false;
      } else if (this.userProfile.lastName.length < 3) {
        this.userProfile.lastNameValidation =
          this.translateService.instant('invalid_Length');
        validation = false;
      } else {
        this.userProfile.lastNameValidation = undefined;
      }

      if (this.userProfile.birthday == null) {
        this.userProfile.birthdayValidation =
          this.translateService.instant('Required');
        validation = false;
      } else {
        this.userProfile.birthdayValidation = undefined;
      }

      const regexPhoneNumber: RegExp = /^\d{8,12}$/;

      const regexNationalCode: RegExp = /^\d{10}$/;

      if (this.userProfile.phoneNumber != null) {
        if (!regexPhoneNumber.test(this.userProfile.phoneNumber)) {
          this.userProfile.phoneNumberValidation =
            this.translateService.instant('invalid_Pattern');
          validation = false;
        } else {
          this.userProfile.phoneNumberValidation = undefined;
        }
      } else {
        this.userProfile.phoneNumberValidation = undefined;
      }

      if (this.userProfile.mobileNumber != null) {
        if (!regexPhoneNumber.test(this.userProfile.mobileNumber)) {
          this.userProfile.mobileNumberValidation =
            this.translateService.instant('invalid_Pattern');
          validation = false;
        } else {
          this.userProfile.mobileNumberValidation = undefined;
        }
      } else {
        this.userProfile.mobileNumberValidation = undefined;
      }

      if (this.userProfile.nationalCode != null) {
        if (!regexNationalCode.test(this.userProfile.nationalCode)) {
          this.userProfile.nationalCodeValidation =
            this.translateService.instant('invalid_Pattern');
          validation = false;
        } else {
          this.userProfile.nationalCodeValidation = undefined;
        }
      } else {
        this.userProfile.nationalCodeValidation = undefined;
      }
    } catch (error) {}

    return validation;
  }

  public UpdateProfile() {
    if (!this.checkValidation()) {
      return;
    }

    try {
      let url = `User/UpdateMySelfItem`;
      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }
      this.loadingUser = true;

      const backendJson = {
        firstName: this.userProfile.firstName,
        lastName: this.userProfile.lastName,
        mobileNumber: this.userProfile.mobileNumber,
        phoneNumber: this.userProfile.phoneNumber,
        birthday: this.userProfile.birthday,
        nationalCode: this.userProfile.nationalCode,
        imageurl: this.userProfile.imageurl,
      };
      this.apiService
        .patchItem(new ApiRequestModel(url, backendJson))
        .subscribe(
          (result) => {
            if (result.succeeded) {
              this.userProfile = result.data;
              this.logger.addResponseLog(url, result, `get Single Item`);
            } else {
              this.apiService.AddErrorLog(result);
            }
            this.loadingUser = false;
          },
          (error) => {
            this.apiService.AddErrorLog(error);
            this.loadingUser = false;
          },
          () => {
            this.loadingUser = false;
          }
        );
    } catch (e) {
      this.logger.addException(e, true);
      this.loadingUser = false;
    }
  }

  public handleFileInput(event: any) {
    const file = event.target.files[0];

    if (file == null) {
      return;
    }

    if (file.type.indexOf('image') < 0) {
      this.logger.addError('Invalid_Image_Format', false);
      return;
    }

    const regex: RegExp = /^.*\.(?<fileType>.{1,})$/;

    if (!regex.test(file.name)) {
      this.logger.addError('Invalid_Image_Format', false);
      return;
    }

    const groups = file.name.match(regex)?.groups;
    const fileType: string = String(groups?.['fileType']);
    if (
      fileType != 'png' &&
      fileType != 'jpeg' &&
      fileType != 'jpg' &&
      fileType != 'PNG' &&
      fileType != 'JPEG' &&
      fileType != 'JPG'
    ) {
      this.logger.addError('Invalid_Image_Format', false);
      return;
    }

    this.uploadFileToActivity(file);
  }

  private uploadFileToActivity(file) {
    if (!this.checkValidation() || file == null) {
      return;
    }

    try {
      let url = `User/UploadProfileImage`;
      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }
      this.loadingUser = true;

      this.apiService.uploadFile(new ApiRequestModel(url), file).subscribe(
        (result) => {
          if (result.succeeded) {
            this.userProfile.imageurl=this.apiService.fixImage(result.data.imageurl);
          } else {
            this.apiService.AddErrorLog(result);
          }
          this.loadingUser = false;
          this.uploadImage=undefined;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loadingUser = false;
          this.uploadImage=undefined;
        },
        () => {
          this.loadingUser = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loadingUser = false;
    }
  }

 
}
